import { Effect, Layer, Result, Scope } from "effect";
import { splitPanePixelRatio } from "../../split-pane-model.ts";
import { defaultPaneSizeFailure } from "./default-size-model.ts";
import { DefaultPaneSizeIo } from "./default-size-service.ts";

export const DefaultPaneSizeIoLive = Layer.succeed(DefaultPaneSizeIo, DefaultPaneSizeIo.of({ watch: (target, input, notify, canRead, report) => Effect.gen(function* () {
  const owner = yield* Scope.Scope;
  const alive = () => owner.state._tag !== "Closed" && canRead();
  const apply = () => {
    if (!alive()) return false;
    const rect = target.getBoundingClientRect();
    const ratio = splitPanePixelRatio({ firstPaneSize: input.firstPaneSize, containerSize: input.vertical ? rect.width : rect.height, bounds: input });
    if (ratio === null) return false;
    notify(ratio);return true;
  };
  const immediate = yield* Effect.try({ try: apply, catch: defaultPaneSizeFailure });
  if (immediate || !alive() || typeof ResizeObserver === "undefined") return;
  const observer = yield* Effect.try({ try: () => new ResizeObserver(() => {
    if (!alive()) return;
    const result = Result.try(() => { if (apply()) observer.disconnect(); });
    if (Result.isFailure(result)) report(defaultPaneSizeFailure(result.failure));
  }), catch: defaultPaneSizeFailure });
  yield* Effect.addFinalizer(() => Effect.try({ try: () => observer.disconnect(), catch: defaultPaneSizeFailure }).pipe(Effect.orDie));
  if (!alive()) return;
  yield* Effect.try({ try: () => observer.observe(target), catch: defaultPaneSizeFailure });
}) }));
